import { Delete } from "@mui/icons-material";
import { Checkbox, FormControlLabel, IconButton, Tooltip, Typography } from "@mui/material";
import React from "react";
import ConfirmDialog from "../../common/ConfirmDialog";
import Service from "../../../util/Service";


export default function TablePortalDeleteComp(props) {
    const { pagina, action } = props;

    const [open, setOpen] = React.useState(false);
    const [completa, setCompleta] = React.useState();

    React.useEffect(() => {
        if (open) {
            buscaPaginaCompleta()
        }
    }, [open])

    function buscaPaginaCompleta() {
        Service.GET("/api/paginaHtml/buscaPorId/" + pagina.id).then(r => setCompleta(r))
    }
    const handleClick = (event) => {
        setOpen(true);
    };

    function handleDelete() {
        Service.GET("/api/security/paginaHtml/remover/" + pagina.id).then(r => {
            console.log(r);
            if( action) action("");
        })


    }

    return (
        <React.Fragment>
            <Tooltip title="Deletar">
                <IconButton onClick={handleClick}>
                    <Delete />
                </IconButton>
            </Tooltip>

            <ConfirmDialog
                open={open}
                setOpen={setOpen}
                ok='Confirma exclusão?'
                cancel="Sair"
                title="Exclusão"
                // body={"Confirma exportar pagina? Isso pode levar alguns minutos"}
                execute={handleDelete}
            >
                <Typography>
                    {"Isso removerá a pagina " + pagina.nome+". Confirma?"}
                </Typography>
                {completa && completa.controller && <Typography>
                    Essa pagina contem controlador.

                    <FormControlLabel control={<Checkbox defaultChecked />} label="Marque tambem para remover o controlador" />


                </Typography>}
            </ConfirmDialog>
        </React.Fragment>
    )
}